import { render, staticRenderFns } from "./PatientForm.vue?vue&type=template&id=4fb73c03&"
import script from "./PatientForm.vue?vue&type=script&lang=js&"
export * from "./PatientForm.vue?vue&type=script&lang=js&"
import style0 from "./PatientForm.vue?vue&type=style&index=0&id=4fb73c03&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports